import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FieldTextAreaAutoSize from '../fields/fieldTextAreaAutoSize';
import { LabelAnswer } from './labelAnswer';

type Props = {
    title?: string;
    placeholder?: string;
    required: false | boolean;
    onChange: (value: any) => void;
    idQuestion?: string;
    questionType?: string;
    type?: 'text' | 'big-text';
};

const FieldTextAnswer = ({
    title,
    placeholder,
    required,
    onChange,
    idQuestion,
    questionType,
    type = 'text',
}: Props) => {
    const formik = useFormik({
        initialValues: {
            idQuestion,
            answer: '',
            type: questionType,
            why: '',
        },
        validationSchema: Yup.object({
            answer: Yup.string().when({
                is: () => required,
                then: (schema) =>
                    schema.required('La respuesta es obligatoria'),
            }),
        }),
        onSubmit: (form) => {
            console.log(form);
        },
    });

    useEffect(() => {
        onChange({
            ...formik.values,
            error:
                Boolean(formik.errors.answer) ||
                !Boolean(formik.values.answer.trim()),
        });
    }, [formik.values]);

    return (
        <>
            <LabelAnswer text={title} />
            <br />
            <FieldTextAreaAutoSize
                name="answer"
                touched={Boolean(formik.errors.answer)}
                errors={formik.errors.answer}
                placeholder={placeholder}
                required={true}
                onChange={formik.handleChange}
                type={type}
            />
        </>
    );
};

export default FieldTextAnswer;
